package com.example.mystybag.sharedmodels.project.requestModels

import com.example.mystybag.sharedmodels.AllCommands.USER_LOGIN
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

@Serializable
data class LoginUserRequestModel(
    val mail        : String    = "",
    val code        : String    = ""
): BaseRequestModel(api = USER_LOGIN)
